import { observable, runInAction } from 'mobx';
import { IProjectManagementServices, ReportCTDAModel } from 'services/Main/projectManagement_services';
import { DataResponse } from 'services/response';

export type ProjectManagementStore = {
    // Báo cáo chi tiết dự án
    reportCTDA: DataResponse<Array<ReportCTDAModel>>
};

export interface IProjectManagementPresenter {
    createStore(): ProjectManagementStore;
    // Lấy data table báo cáo chi tiết dự án
    getDataReportCTDA(store: ProjectManagementStore, dataSearch: Object): Promise<void>
    // Xuất Excel báo cáo chi tiết dự án
    exportExportReportCTDA(dataSearch: Object): Promise<void>
}

export function createProjectManagementPresenter({ projectManagementServices }: { projectManagementServices: IProjectManagementServices }): IProjectManagementPresenter {
    return {
        createStore: (): ProjectManagementStore =>
            observable({
                // Báo cáo chi tiết dự án
                reportCTDA: {
                    data: [],
                    message: '',
                    isSuccess: false,
                    paging: {
                        totalCount: 0,
                        pageIndex: 0,
                        pageSize: 0,
                        totalPages: 0
                    }
                }
            }),
        getDataReportCTDA: async (store, dataSearch) => {
            try {
                const result = await projectManagementServices.getDataCTDAReport(dataSearch);
                runInAction(() => {
                    store.reportCTDA.data = result.data;
                    store.reportCTDA.isSuccess = result.isSuccess;
                    store.reportCTDA.message = result.message;
                    store.reportCTDA.paging = result.paging;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Xuất Excel báo cáo chi tiết dự án
        exportExportReportCTDA: async (dataSearch) => {
            try {
                await projectManagementServices.exportExportReportCTDA(dataSearch);

            } catch (error) {
                console.log(error);
            }
        }
    };
}
